import React from "react";
import { Tooltip } from "antd";
import { ColumnsType } from "antd/lib/table";
import { History, Out, UserOutlined, View } from "assets/icons";
import { IDocumentInfo } from "components/documentInfo/DocumentInfo";
import ViewDocument from "components/documentInfo/ViewDocument";
import dayjs from "dayjs";
import { IColumn } from "typings/global";
import { convertTimeSpanToTime, truncateText, unauthorizedRolesInLobbyTableActions } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./../styled/index.styled";

const ColumnsTable = ({ handlesClickInbound, isConcierge, allowRequestDockEntryAction, userData }) => {
  const CARRIER = useTranslation({ id: "carrier" });
  const PLATE = useTranslation({ id: "plate" });
  const TRAILERS_PLATE = useTranslation({ id: "trailers_plate" });
  const PROCESSES = useTranslation({ id: "processes" });
  const DOCUMENTS = useTranslation({ id: "documents" });
  const ENTRY = useTranslation({ id: "entry" });
  const STAY = useTranslation({ id: "stay" });
  const ACTIONS = useTranslation({ id: "actions" });
  const VIEW_ENTRY = useTranslation({ id: "view_entry" });
  const CALL_DRIVER = useTranslation({ id: "call_driver" });
  const CHECK_OUT = useTranslation({ id: "check_out" });
  const EVENT_HISTORY = useTranslation({ id: "events_history" });

  const collums: Array<IColumn> = [
    {
      title: CARRIER,
      dataIndex: "carrier",
      width: "29%",
      key: "carrier",
      render: (carrier: string) => truncateText(carrier),
    },
    {
      title: PLATE,
      dataIndex: "vehiclePlate",
      width: "10%",
      key: "vehiclePlate",
      render: (vehiclePlate: ColumnsType<string>) => `${vehiclePlate}`,
    },
    {
      title: TRAILERS_PLATE,
      dataIndex: "trailersplate",
      width: "10%",
      key: "trailersplate",
      render: (trailersplate: ColumnsType<string>) => (trailersplate === undefined || trailersplate?.length === 0 ? "--" : <span>{trailersplate.join("\n")}</span>),
    },
    {
      title: PROCESSES,
      dataIndex: "process",
      width: "15%",
      key: "process",
      render: (process: ColumnsType<string>) => `${process}`,
    },
    {
      title: DOCUMENTS,
      dataIndex: "documents",
      width: "7%",
      key: "documents",
      render: (documents: Array<IDocumentInfo>, record) => <ViewDocument record={record} documents={documents} handlesClick={handlesClickInbound} />,
    },
    {
      title: ENTRY,
      dataIndex: "inboundEventTime",
      width: "10%",
      key: "inboundEventTime",
      render: (inboundEventTime: string) => (inboundEventTime ? `${dayjs.utc(inboundEventTime).local().format("DD/MM/YYYY HH:mm")}` : "--"),
    },
    {
      title: STAY,
      width: "10%",
      dataIndex: "lenghtOfStay",
      key: "lenghtOfStay",
      render: (_, record) => (record.lenghtOfStay !== null ? `${convertTimeSpanToTime(record.lenghtOfStay)}` : "--"),
    },
    {
      title: ACTIONS,
      dataIndex: "action",
      width: "9%",
      key: "actions",
      render: (_, record) =>
        record.action === true && (
          <S.ActionContainer allowRequestDockEntryAction={allowRequestDockEntryAction}>
            <button onClick={() => handlesClickInbound.handleClickView(record)} data-testid="view-register">
              <Tooltip placement="top" title={VIEW_ENTRY}>
                <View className="viewRegister" data-testid="view-register-icon" />
              </Tooltip>
            </button>
            {allowRequestDockEntryAction && (
              <button
                onClick={() => handlesClickInbound.handleClickVehicleAction(record)}
                data-testid="vehicle-action-register"
                hidden={unauthorizedRolesInLobbyTableActions(userData.role)}
              >
                <Tooltip placement="top" title={CALL_DRIVER}>
                  <UserOutlined className="vehicleActionRegister" data-testid="vehicle-action-icon" />
                </Tooltip>
              </button>
            )}
            <button onClick={() => handlesClickInbound.handleClickOutBound(record)} data-testid="outbound-register" hidden={!isConcierge}>
              <Tooltip placement="top" title={CHECK_OUT}>
                <Out className="outRegister" data-testid="out-register-icon" />
              </Tooltip>
            </button>
            <button data-testid="vehicle-entry-authorization" onClick={() => handlesClickInbound.handleClickVehicleEntryAuthorization(record)}>
              <Tooltip placement="top" title={EVENT_HISTORY}>
                <History data-testid="vehicle-entry-authorization-icon" className="vehicleEntryAuthorization" />
              </Tooltip>
            </button>
          </S.ActionContainer>
        ),
    },
  ];
  return collums;
};

export default ColumnsTable;
